import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MojoPrivilegesModule } from 'mojo-privileges';

import { AggregationsEffects } from '@collections/aggregations';
import { AssociationLabelEffects } from '@collections/association-label';
import { AssociationsEffects } from '@collections/associations';
import { AttachmentsEffects } from '@collections/attachments';
import { CandidatesEffects } from '@collections/candidates';
import { CompaniesEffects } from '@collections/companies';
import { FeedbackEffects } from '@collections/feedback';
import { HiringManagerStatusEffects } from '@collections/hiring-manager-status';
import { JobBoardEffects } from '@collections/job-boards';
import { JobsEffects } from '@collections/jobs';
import { RolesEffects } from '@collections/roles';
import { UsersEffects } from '@collections/users';

import { ApplicationHistoryEffects } from './application-history/application-history.effects';
import { CollectionsConfig } from './collections.abstract.config';
import { collectionsConfig } from './collections.config';
import { reducers } from './collections.reducer';
import { EmailTemplatesEffects } from './email-templates/email-templates.effects';
import { ManagersEffects } from './managers/managers.effects';
import { NotificationsEffects } from './notifications/notifications.effects';
import { ReferralEffects } from './referral/referral.effects';
import { SharedResourcesEffects } from '@core/shared-resources/store/shared-resources.effects';
import { ActivityTrackingEffects } from '@core/activity-tracking/activity-tracking.effects';

export const effects = [
  AggregationsEffects,
  ApplicationHistoryEffects,
  AssociationLabelEffects,
  AssociationsEffects,
  AttachmentsEffects,
  CandidatesEffects,
  CompaniesEffects,
  FeedbackEffects,
  JobBoardEffects,
  JobsEffects,
  ManagersEffects,
  NotificationsEffects,
  ReferralEffects,
  RolesEffects,
  UsersEffects,
  HiringManagerStatusEffects,
  EmailTemplatesEffects,
  SharedResourcesEffects,
  ActivityTrackingEffects,
];

@NgModule({
  imports: [
    StoreModule.forFeature('collections', reducers),
    EffectsModule.forFeature([...effects]),
    MojoPrivilegesModule,
  ],
  providers: [
    ...effects,
    {
      provide: CollectionsConfig,
      useValue: collectionsConfig,
    },
  ],
})
export class CollectionsModule {}
